export { default as QuickBookingRestShortC } from './QuickBookingRestShortC'
export { default as QuickBookingRestShortCSkeleton } from './Skeleton'
